import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M6 7.25C6 6.836 5.664 6.5 5.25 6.5H0.75C0.336 6.5 0 6.836 0 7.25C0 7.664 0.336 8 0.75 8H5.25C5.664 8 6 7.664 6 7.25Z',
                    fill: '#FFC107',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M5.25 9.5H2.25C1.836 9.5 1.5 9.836 1.5 10.25C1.5 10.664 1.836 11 2.25 11H5.25C5.664 11 6 10.664 6 10.25C6 9.836 5.664 9.5 5.25 9.5Z',
                    fill: '#FFC107',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M5.25 12.5H3.75C3.336 12.5 3 12.836 3 13.25C3 13.664 3.336 14 3.75 14H5.25C5.664 14 6 13.664 6 13.25C6 12.836 5.664 12.5 5.25 12.5Z',
                    fill: '#FFC107',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M23.8935 12.1145L21.6435 8.3645C21.5085 8.138 21.264 8 21 8H15.75C15.336 8 15 8.336 15 8.75V16.25C15 16.664 15.336 17 15.75 17H23.25C23.664 17 24 16.664 24 16.25V12.5C24 12.3635 23.964 12.23 23.8935 12.1145Z',
                    fill: '#F44336',
                },
            },
            {
                tag: 'path',
                attr: { d: 'M18 9.5H20.5755L22.3755 12.5H18V9.5Z', fill: '#FAFAFA' },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M15.75 5H5.25C4.836 5 4.5 5.336 4.5 5.75V16.25C4.5 16.664 4.836 17 5.25 17H16.5V5.75C16.5 5.336 16.164 5 15.75 5Z',
                    fill: '#FFC107',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M20.25 17.75C21.0784 17.75 21.75 17.0784 21.75 16.25C21.75 15.4216 21.0784 14.75 20.25 14.75C19.4216 14.75 18.75 15.4216 18.75 16.25C18.75 17.0784 19.4216 17.75 20.25 17.75Z',
                    fill: '#FAFAFA',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M20.25 18.5C19.0095 18.5 18 17.4905 18 16.25C18 15.0095 19.0095 14 20.25 14C21.4905 14 22.5 15.0095 22.5 16.25C22.5 17.4905 21.4905 18.5 20.25 18.5ZM20.25 15.5C19.8375 15.5 19.5 15.8375 19.5 16.25C19.5 16.6625 19.8375 17 20.25 17C20.6625 17 21 16.6625 21 16.25C21 15.8375 20.6625 15.5 20.25 15.5Z',
                    fill: '#455A64',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M16.5 17H5.25C4.836 17 4.5 16.664 4.5 16.25V14H16.5V17Z',
                    fill: '#F44336',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M9.75 17.75C10.5784 17.75 11.25 17.0784 11.25 16.25C11.25 15.4216 10.5784 14.75 9.75 14.75C8.92157 14.75 8.25 15.4216 8.25 16.25C8.25 17.0784 8.92157 17.75 9.75 17.75Z',
                    fill: '#FAFAFA',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M9.75 18.5C8.5095 18.5 7.5 17.4905 7.5 16.25C7.5 15.0095 8.5095 14 9.75 14C10.9905 14 12 15.0095 12 16.25C12 17.4905 10.9905 18.5 9.75 18.5ZM9.75 15.5C9.336 15.5 9 15.8375 9 16.25C9 16.6625 9.336 17 9.75 17C10.164 17 10.5 16.6625 10.5 16.25C10.5 15.8375 10.164 15.5 9.75 15.5Z',
                    fill: '#455A64',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const ShippingColored = React.forwardRef(IconComponent);
ShippingColored.displayName = 'ShippingColored';

export { ShippingColored };
